import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: number;
  constructor(private readonly loader: LoaderService) {
    this.requests = 0;
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loader.setProgress('json');
    if (req.headers.get('multimedia')) {
      this.loader.setProgress('multimedia#' + req.headers.get('multimedia'));
    }

    this.requests++;

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.requests--;
          if (this.requests >= 0) {
            this.loader.setProgress('');
          }
        }
      })
    );
  }
}
